import moment from "moment";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { appConfigService } from "services/appConfigService";
import languageService from "pages/SystemConfig/services/languageService";
import { setWith } from "lodash";
import Cache from "i18next-localstorage-cache";
import i18next from "i18next";

const initialLang = appConfigService.getItem("lang") || "en";

i18n
  .use(Cache)
  .use(initReactI18next)
  .init({
    // cache: { enabled: true },
    resources: {},
    lng: initialLang,
    initImmediate: false,
    interpolation: {
      escapeValue: false,
    },
  });

const initI18n = async () => {
  if (initialLang === "vi") {
    // @ts-ignore
    await import("moment/locale/vi");
  } else {
    // @ts-ignore
    await require("moment/locale/en-gb");
  }
  moment.locale(initialLang === "vi" ? "vi" : "en-gb");
  const languages = await languageService.getTranslateItems({
    limit: 9999,
    offset: 0,
  });
  const resources = languages?.data?.reduce(
    (acc, item) => {
      const { en, vi, key } = item;
      if (key) {
        setWith(acc, `en.translation.${key}`, en, Object);
        setWith(acc, `vi.translation.${key}`, vi, Object);
      }
      return acc;
    },
    { en: { translation: {} }, vi: { translation: {} } }
  );

  i18next.addResourceBundle("en", "translation", resources.en.translation);
  i18next.addResourceBundle("vi", "translation", resources.vi.translation);

  return null;
};

export default initI18n;
